import React, { useState } from 'react';
import { CountdownTimer } from './CountdownTimer';
const comparisonRows = [{
  without: '❌ 100h/año planificando desde cero',
  with: '✅ 10 min/semana. Todo listo.'
}, {
  without: '❌ Ejercicios improvisados sin progresión',
  with: '✅ 101 drills + 6 tomos por nivel'
}, {
  without: '❌ 60% de abandono y sin evaluación',
  with: '✅ Retención +80% con fichas de progreso'
}, {
  without: '❌ Sin gestión ni identidad profesional',
  with: '✅ Reglamento + sistema para cobrar más'
}];
interface PricingOption {
  id: string;
  emoji: string;
  title: string;
  description: string;
  originalPrice: string;
  price: string;
  ctaText: string;
  ctaHref: string;
  isFeatured?: boolean;
  savings?: string;
}
const options: PricingOption[] = [{
  id: 'megapack',
  emoji: '📘',
  title: 'MEGAPACK VOLEY LISTO',
  description: '6 tomos + 6 bonos',
  originalPrice: 'USD 24,90',
  price: 'USD 13,90',
  ctaText: '→ SÍ, QUIERO EL MEGAPACK',
  ctaHref: 'https://docentes2.edulabs.online/cart/43273417097334:1'
}, {
  id: 'elite',
  emoji: '🏆',
  title: 'MEGAPACK + KIT TÁCTICO PRO',
  description: '6 tomos + 6 bonos + Kit Táctico Pro™ (pizarras, señales, scouting)',
  originalPrice: 'USD 31,90',
  price: 'USD 19,90',
  ctaText: '→ SÍ, QUIERO EL MEGAPACK + KIT TÁCTICO PRO',
  ctaHref: 'https://docentes2.edulabs.online/cart/43273433809014:1',
  isFeatured: true,
  savings: 'AHORRAS USD 12'
}];
export function FinalCTA() {
  const [selected, setSelected] = useState('elite');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section className="w-full bg-[#0A0A0F] py-14 px-4" data-id="element-51">
      <div className="max-w-lg mx-auto" data-id="element-52">
        {/* Headline */}
        <h2 className="text-2xl sm:text-3xl font-black text-white text-center mb-6" data-id="element-53">
          ¿Cuánto cuesta <span className="text-[#FF6B00]" data-id="element-54">NO tenerlo?</span>
        </h2>

        {/* Compact comparison */}
        <div className="bg-[#16161F] border border-[#FF6B0033] rounded-xl overflow-hidden mb-8" data-id="element-55">
          <div className="grid grid-cols-2 bg-[#0A0A0F] border-b border-[#FF6B0033]" data-id="element-56">
            <div className="px-4 py-2.5 font-bold text-[#B0B0C0] text-xs text-center" data-id="element-57">
              Sin EDULABS
            </div>
            <div className="px-4 py-2.5 font-bold text-[#FF6B00] text-xs text-center border-l border-[#FF6B0033]" data-id="element-58">
              Con EDULABS
            </div>
          </div>
          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-[#FF6B0033]' : ''}`} data-id="element-59">
              <div className="px-4 py-2.5 text-[#B0B0C0] text-xs" data-id="element-60">
                {row.without}
              </div>
              <div className="px-4 py-2.5 text-white font-semibold text-xs bg-[#FF6B00]/5 border-l border-[#FF6B0033]" data-id="element-61">
                {row.with}
              </div>
            </div>)}
        </div>

        {/* Closing copy */}
        <div className="text-center mb-8" data-id="element-62">
          <p className="text-white text-base sm:text-lg font-bold mb-1" data-id="element-63">
            El lunes puedes <span className="text-[#FF6B00]" data-id="element-64">improvisar</span> o
            entrar con todo resuelto.
          </p>
          <p className="text-[#B0B0C0] text-xs" data-id="element-65">Tú decides.</p>
        </div>

        {/* Countdown */}
        <div className="text-center mb-6" data-id="element-66">
          <p className="text-[#FF6B00] text-xs font-bold mb-2" data-id="element-67">
            ⏰ Precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="md" blinking={true} data-id="element-68" />
          <p className="text-[#B0B0C0] text-[10px] mt-1.5" data-id="element-69">
            Después sube USD 5 y no vuelve.
          </p>
        </div>

        {/* Options */}
        <div className="space-y-3 mb-4 text-left" data-id="element-70">
          {options.map(option => {
          const isSelected = selected === option.id;
          const isFeatured = option.isFeatured;
          return <button key={option.id} onClick={() => setSelected(option.id)} className={`w-full text-left rounded-xl p-4 transition-all bg-[#16161F] relative overflow-hidden ${isSelected && isFeatured ? 'border-2 border-[#FF6B00] shadow-[0_0_40px_rgba(255,107,0,0.12)]' : isSelected ? 'border-2 border-[#FF6B00]' : 'border border-[#333340]'}`} data-id="element-71">
                {isFeatured && <div className="absolute top-0 right-0 bg-[#FFD700] text-[#0A0A0F] text-[9px] font-black px-3 py-0.5 rounded-bl-lg" data-id="element-72">
                    ⭐ MÁS ELEGIDO
                  </div>}
                <div className="flex items-center gap-3" data-id="element-73">
                  <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${isSelected ? 'border-[#FF6B00]' : 'border-[#333340]'}`} data-id="element-74">
                    {isSelected && <div className="w-2.5 h-2.5 rounded-full bg-[#FF6B00]" data-id="element-75" />}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-76">
                    <div className="flex items-center gap-2" data-id="element-77">
                      <span className="text-base" data-id="element-78">{option.emoji}</span>
                      <span className="text-white font-bold text-sm" data-id="element-79">
                        {option.title}
                      </span>
                    </div>
                    <p className="text-[#B0B0C0] text-xs mt-0.5" data-id="element-80">
                      {option.description}
                    </p>
                    {option.savings && <span className="inline-block bg-[#FF6B0033] text-[#FF6B00] text-[10px] font-bold px-2 py-0.5 rounded-full mt-1" data-id="element-81">
                        {option.savings}
                      </span>}
                  </div>
                  <div className="text-right flex-shrink-0" data-id="element-82">
                    <div className="text-[#B0B0C0] line-through text-[10px]" data-id="element-83">
                      {option.originalPrice}
                    </div>
                    <div className="font-black text-xl text-white" data-id="element-84">
                      {option.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* CTA */}
        <a href={selectedOption.ctaHref} className="btn-primary-pulse block w-full text-center bg-[#FF6B00] font-black text-base sm:text-lg py-4 rounded-xl hover:bg-[#ff8533] transition-colors text-white mb-4" data-id="element-85">
          {selectedOption.ctaText}
        </a>

        {/* Trust */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-[10px] sm:text-xs text-[#B0B0C0]" data-id="element-86">
          <span data-id="element-87">🔒 Pago seguro</span>
          <span data-id="element-88">⚡ Acceso en 5 min</span>
          <span data-id="element-89">🛡️ Garantía 7 días</span>
          <span data-id="element-90">💳 Tarjeta · PayPal</span>
        </div>
      </div>
    </section>;
}